import { Link } from 'react-router-dom';
import { WORK_ITEMS, RESUME_URL } from '../config/workConfig';

function Welcome() {
  return (
    <div className="landing-page">
      <div className="hero-content">
        <p className="hero-label">Chinmay Joshi</p>
        <h1 className="hero-title">
          Principal Product Designer
        </h1>
        <p className="hero-subtitle">
          I lead design for AI-powered products at Nextiva, mostly where a complex system has to stay understandable and in the user's control. My work spans AI products, design systems, and enterprise UX.
        </p>
        <div className="hero-cta">
          <a href="#work" className="btn btn-primary">
            View work
          </a>
          <a href={RESUME_URL} className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
            View resume
          </a>
        </div>
      </div>
      <div id="work" className="hero-work-strip">
        <p className="hero-work-strip-label">Selected work</p>
        <div className="hero-work-strip-list">
          {WORK_ITEMS.map((item) => {
            const to = item.protected
              ? `/password?redirect=${encodeURIComponent(item.slug)}`
              : item.slug;
            return (
              <Link key={item.slug} to={to} className="hero-work-strip-item">
                {item.icon && (
                  <span className="hero-work-strip-icon" aria-hidden="true">
                    <item.icon />
                  </span>
                )}
                <span className="hero-work-strip-content">
                  <span className="hero-work-strip-title">{item.projectName}</span>
                  <span className="hero-work-strip-desc">{item.description}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Welcome;
